import React from 'react';
import { StyleSheetManager } from 'styled-components';
import isValidProp from '@emotion/is-prop-valid';

const StyledComponentManager = (props: any) => {
  return (
    <StyleSheetManager
      shouldForwardProp={(propName: any) => isValidProp(propName)}
    >
      {props.children}
    </StyleSheetManager>
  );
};

export default StyledComponentManager;
